module.exports = __webpack_public_path__ + "static/media/Heatmap.d64908f8.svg";